import { setIn } from 'final-form';
import { object, string, array} from 'yup';
import { DRONE_TYPES, MULTIMEDIA_TYPES } from '../../config'

const STEP_1 = {
  uploadType: string()
    .nullable(true)
    .required(),
};

// TODO
// - project date proper validation
// - validate input length
// - files validation
const STEP_2 = {
  projectName: string()
    .nullable(true)
    .required('Project name is required'),
  projectDescription: string()
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      DRONE_TYPES.includes(uploadType) ? schema.required('Project description is required') : schema
    ),
  projectDate: string()
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      DRONE_TYPES.includes(uploadType) ? schema.required('Project date is required') : schema
    ),
  drone: string()
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      DRONE_TYPES.includes(uploadType) ? schema.required('Drone is required') : schema
    ),
  flightName: string()
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      MULTIMEDIA_TYPES.includes(uploadType) ? schema.required('Flight name is required') : schema
    ),
  flightPurpose: string()
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      DRONE_TYPES.includes(uploadType) ? schema.required('Flight purpose is required') : schema
    ),
  location: object().shape({})
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      DRONE_TYPES.includes(uploadType) ? schema.required('Location is required') : schema
    ),
  realEstate: string()
    .nullable(true)
    .when('uploadType',(uploadType, schema) =>
      uploadType === 'video' ? schema.required('Real estate is required') : schema
    ),
}

const STEP_3 = {
  files: array()
    .required()
    .min(1, 'min 1'),
};

const SCHEMA_1 = object({
  ...STEP_1,
});

const SCHEMA_2 = object({
  ...STEP_2,
});

const SCHEMA_3 = object({
  ...STEP_3,
});

export const VALIDATION_SCHEMAS = [
  null,
  SCHEMA_1,
  SCHEMA_2,
  SCHEMA_3,
];

export const validateFormValues = () => async (
  values,
) => {
  let formSchema = VALIDATION_SCHEMAS[values.currentStep];

  return formSchema
    .validate(values, {
      abortEarly: false,
      context: {},
    })
    .then(() =>
      // everything ok, return an empty response
      Promise.resolve(),
    )
    .catch((err) => {
      // build an object that resembles the form state, with
      // error messages as values
      const errors = err.inner.reduce(
        (formError, innerError) =>
          setIn(formError, innerError.path, innerError.message),
        {},
      );

      // return a resolved promise with the error object
      return Promise.resolve(errors);
    });
};
